<template>
  <div id="app">
    <div id="nav">
      <Header />
    </div>
    <div id="main">
      <router-view/>
    </div>
    <div id="footer">
      <Footer/>
    </div>
  </div>
</template>

<script>
import '@/assets/icomoon/style.css'
import Header from './components/Header'
import Footer from './components/Footer'
export default {
  components:{
    Header,
    Footer
  }
}
</script>

<style>
#app {
  font-family: sans-serif, 'Avenir', Helvetica, Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #262626;
  font-size: 18px;
}

#app a{
  color: #1EA1F2;
}
h1, h2, h3, h4, h5, h6 {
    margin: 0;
    font-weight: 700;
    line-height: 1.5;
    outline: 0;
}
#footer {
  max-width: 1120px;
  margin:auto
}
</style>
